// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import CreateTemplatePopup from "../CreateTemplatePopup";
import DocTemplateItem from "./DocTemplateItem";
import TitleBar from "../TitleBar";
import { EmptyScreen } from "../../commonComponents";
import withRbac from "../../app/withRbac";

// Actions Imports
import { DocumentTemplateActions } from "../../actions";

// Internal Imports
import TemplateEmptyImageSrc from "../../assets/Select-account.png";
import { PERMISSIONS } from "../../constants";
import { GlobalUtils } from "../../utils";

// Destructuring
const { getTemplateInitData } = DocumentTemplateActions;
const { handleApiErrMsg } = GlobalUtils;

class ListDocTemplates extends Component {
  state = {
    showLoader: false,
    createTemplatePopup: false,
  };

  componentDidMount() {
    this._onInitTemplates();
  }

  // Fetch templates and document types
  _onInitTemplates = () => {
    this.setState({ showLoader: true });
    this.props
      .getTemplateInitData()
      .then(() => {
        this.setState({ showLoader: false });
      })
      .catch(error => {
        console.error(`ListDocTemplates => _onInitTemplates => ${error}`);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ showLoader: false });
      });
  };

  _createTemplate = () => {
    this.setState({ createTemplatePopup: true });
  };

  _closeCreateTemplatePopup = () => {
    this.setState({ createTemplatePopup: false });
  };

  _getTemplatesList = templateList => {
    if (templateList.length > 0) {
      return (
        <Fragment>
          <div
            data-test="listdoctemplates-templatelist-header-container"
            className="templatelist-header-container">
            <div
              data-test="listdoctemplates-templatelist-header-row"
              className="row templatelist-header">
              <div
                data-test="listdoctemplates-templatelist-header-row-templatename"
                className="col-md-3 template-name">
                TEMPLATE NAME
              </div>
              <div
                data-test="listdoctemplates-templatelist-header-row-templatetype"
                className="col-md-3 template-type">
                TYPE
              </div>
              <div
                data-test="listdoctemplates-templatelist-header-row-templateowner"
                className="col-md-2 template-owner">
                LAST EDITED BY
              </div>
              <div
                data-test="listdoctemplates-templatelist-header-row-lasteditedon"
                className="col-md-2">
                LAST EDITED ON
              </div>
              <div
                data-test="listdoctemplates-templatelist-header-row-templatestatus"
                className="col-md-1 template-status">
                <span
                  data-test="listdoctemplates-templatelist-header-row-status"
                  className="template-status-toggle">
                  STATUS
                </span>
              </div>
              <div
                data-test="listdoctemplates-templatelist-header-row-deletecloneoptions"
                className="col-md-1"
              />
            </div>
          </div>

          <div>
            {templateList.map(template => (
              <DocTemplateItem key={template.id} template={template} />
            ))}
          </div>
        </Fragment>
      );
    }

    return (
      <EmptyScreen
        imageSrc={TemplateEmptyImageSrc}
        message="There are no templates available"
      />
    );
  };

  render() {
    const { createTemplatePopup } = this.state;
    const { documentTemplates } = this.props;
    const CreateNewTemplateBtn = withRbac(() => (
      <Button
        data-test="listdoctemplates-create-new-template-button"
        className="btn btn-primary invite-button"
        onClick={event => this._createTemplate(event)}>
        Create new template
      </Button>
    ));

    // Show screen loader while fetching the templates list
    if (this.state.showLoader) {
      return <Loader />;
    }

    return (
      <div className="templates-container">
        {/* -------- Create Template popup -------- */}
        {createTemplatePopup && (
          <CreateTemplatePopup
            show={createTemplatePopup}
            closePopup={this._closeCreateTemplatePopup}
          />
        )}
        {/* -------- Template title bar -------- */}
        <div className="page-topbar">
          <TitleBar
            iconName="files-medical"
            title="Templates"
            subTitle="This is the place to manage all the templates"
          />
        </div>
        <div
          data-test="listdoctemplates-templates-section"
          className="templates-section">
          {/* -------- Template left main section -------- */}
          <div
            data-test="listdoctemplates-templates-accounts-wrapper"
            className="templates-accounts-wrapper">
            <div
              data-test="listdoctemplates-templates-tab-options"
              className="templates-tab-options">
              <ul
                data-test="listdoctemplates-templates-tab-options-ul"
                className="templates-tab-options-ul">
                <li
                  data-test="listdoctemplates-templates-tab-option-managetemplates"
                  className="templates-tab-options-li active">
                  <i
                    data-test="listdoctemplates-templates-tab-options-icon"
                    className="templates-tab-options-icon">
                    <FontAwesomeIcon icon={["far", "file-alt"]} />
                  </i>
                  Manage Templates
                </li>
                {/* <li>
                  <i>
                    <FontAwesomeIcon icon={["far", "puzzle-piece"]} />
                  </i>
                  Clause Library
                </li> */}
              </ul>
            </div>
          </div>

          {/* -------- Template right main section -------- */}
          <div
            data-test="listdoctemplates-templates-opportunities-wrapper"
            className="templates-opportunities-wrapper">
            <div
              data-test="listdoctemplates-templates-opportunities-list"
              className="templates-opportunities-list">
              <div
                data-test="listdoctemplates-templatelist-title"
                className=" templatelist-title ">
                <div className="">
                  <div
                    data-test="listdoctemplates-account-section-heading"
                    className="account-section-heading">
                    Manage Templates
                  </div>
                  <div
                    data-test="listdoctemplates-account-section-subheading"
                    className="account-section-subheading">
                    You can create and manage your templates here.
                  </div>
                </div>
                <div className="create-container">
                  <CreateNewTemplateBtn
                    permission={PERMISSIONS.TEMPLATES.CREATE_TEMPLATES}
                  />
                </div>
              </div>
              {/* -------- Templates list section-------- */}
              {this._getTemplatesList(documentTemplates)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { documentTemplates } = state.TemplateStore;
  return { documentTemplates };
};

const mapDispatchToProps = {
  getTemplateInitData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ListDocTemplates));



// WEBPACK FOOTER //
// ./src/components/DocTemplates/ListDocTemplates.js